import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { DropdownSearchComponent } from '@irb-common/components/dropdown-search/dropdown-search.component';
import { UtilityService } from '@irb-common/services/utility.service';
import { MatchComponent } from '@irb-common/components/grid/renderers/match.cell.component';

@Injectable({
    providedIn: 'root'
})
export class DropdownSearchGridLayoutService implements GridLayoutService<DropdownSearchComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {
            "MatchComponent": MatchComponent
        };
    }

    getColumnDefs() {
        return [{
            headerName: 'Name',
            field: 'name',
            suppressFloatingFilterButton: true,
            cellRenderer: "MatchComponent",
            sortable: false,
            flex: 1
        }];
    }
}
